module.exports = __webpack_public_path__ + "images/feature/doc-auto-save-efe514f003bb1c1e0bc9d7f2ea6d1a6c.gif";